module.exports = __webpack_public_path__ + "static/media/i2.db835b12.jpg";